import React from 'react';

export const CommunicationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M16.666 1.66699C17.3289 1.66699 17.9648 1.9298 18.4336 2.39844C18.9024 2.86728 19.166 3.50395 19.166 4.16699V14.167C19.1659 14.8299 18.9024 15.4658 18.4336 15.9346C17.9648 16.4033 17.329 16.667 16.666 16.667H5.68945C5.46848 16.6671 5.25681 16.7549 5.10059 16.9111L3.26562 18.7461C3.06634 18.9453 2.81156 19.0808 2.53516 19.1357C2.25889 19.1906 1.97214 19.1625 1.71191 19.0547C1.45186 18.9469 1.22973 18.7643 1.07324 18.5303C0.916658 18.296 0.833044 18.0201 0.833008 17.7383V4.16699C0.833008 3.50395 1.09561 2.86728 1.56445 2.39844C2.03329 1.9296 2.66997 1.66699 3.33301 1.66699H16.666ZM3.33301 3.33301C3.11199 3.33301 2.89944 3.42087 2.74316 3.57715C2.58688 3.73343 2.49902 3.94598 2.49902 4.16699V17.1553L3.92188 15.7324L4.10547 15.5664C4.55019 15.202 5.10946 15.0001 5.68945 15H16.666C16.887 15 17.0986 14.912 17.2549 14.7559C17.4111 14.5997 17.4989 14.3879 17.499 14.167V4.16699C17.499 3.94598 17.4112 3.73343 17.2549 3.57715C17.0986 3.42107 16.8869 3.33301 16.666 3.33301H3.33301Z"
      fill="#B788DC"
    />
  </svg>
);
